<template>
  <div>
    <div
      id="teamWithdrawalItemModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div
                    class="card-body"
                    style="
                      border-style: solid;
                      border-color: #c4c4c4;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="row" style="margin: 10px 0">
                      <div class="col-md-12">
                        <input
                          type="text"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="服務項目"
                          v-model="feeItem"
                        />
                        <input
                          type="number"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="未到期手續%"
                          v-model="non_expired_fee"
                        />
                        <input
                          type="number"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="到期手續%"
                          v-model="expired_fee"
                        />
                        <input
                          type="text"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="備註"
                          v-model="note"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pull-right">
              <button class="btn btn-primary" @click="addFareItem">
                +增加費用項目
              </button>
            </div>
            <table class="table table-striped jambo_table bulk_action">
              <thead>
                <tr class="headings fontSize16">
                  <th class="column-title">費用項目</th>
                  <th class="column-title">未期手續費%</th>
                  <th class="column-title">到期手續費%</th>
                  <th class="column-title">備註</th>
                  <th class="column-title">動作</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in withdrawalTeamItem">
                  <tr class="pointer fontSize16">
                    <td class="">
                      {{ item.name }}
                    </td>
                    <td class=" ">
                      {{ item.nonExpiredProcessingFee }}
                    </td>
                    <td class=" ">
                      {{ item.expiredProcessingFee }}
                    </td>
                    <td class=" ">
                      {{ item.note }}
                    </td>
                    <td class=" ">
                      <button
                        class="btn btn-danger"
                        @click="sealServiceItem(item.id)"
                      >
                        封存
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'

export default {
  data() {
    return {
      withdrawalTeamItem: [],
      withdrawalItems: [],
      feeItem: '',
      non_expired_fee: 0,
      expired_fee: 0,
      note: '',
    }
  },
  mounted() {
    this.getTeamWithdrawalFeeItem()
  },
  methods: {
    sealServiceItem(id) {
      EnterpriseAPI.put(`enterprise/withdrawal/seal/teamItem?id=${id}`)
        .then((res) => {
          if (res.result === '封存成功') {
            this.initialData()
            this.getTeamWithdrawalFeeItem()
          }
        })
        .catch((err) => {
          console.error('saveCustomerInfo', err)
        })
    },
    showModal() {
      /* console.log('=======') */
      $('#teamWithdrawalItemModal').modal('show')
    },
    getTeamWithdrawalFeeItem() {
      EnterpriseAPI.get('enterprise/withdrawal/teamItem')
        .then((res) => {
          //console.log(res.result)
          this.withdrawalTeamItem = res.result.list
        })
        .catch((err) => {
          console.error('saveCustomerInfo', err)
        })
    },
    addFareItem() {
      let payload = {
        name: this.feeItem,
        nonExpiredProcessingFee: this.non_expired_fee,
        expiredProcessingFee: this.expired_fee,
        note: this.note,
      }
      //console.log(payload)
      EnterpriseAPI.post('enterprise/withdrawal/teamItem', payload)
        .then((res) => {
          if (res.result === '新增成功') {
            this.initialData()
            this.getTeamWithdrawalFeeItem()
          }
        })
        .catch((err) => {
          console.error('saveCustomerInfo', err)
        })
    },
    initialData() {
      this.feeItem = ''
      this.non_expired_fee = ''
      this.expired_fee = ''
      this.note = ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/company/TeamWithdrawalItemModal.vue